export default "__VITE_ASSET__8866ee37__"